import React from 'react';
import { Margin, P, TextLink } from '@ovotech/nebula';
import {
  CHARGE_ANYTIME_TERMS_AND_CONDITIONS_LINK,
  VOLVO_PARTNER_RATE_TERMS_LINK,
} from '@/src/constants/links';
import { StyledTermsCheckbox } from '@/src/pages/AnytimeEligibilityV2/pages/DataSharingAndTCConsent/DataSharingAndTCConsent.styled';

interface VolvoPartnerRateTermsProps {
  checked: boolean;
  setChecked: (checked: boolean) => void;
  isError: boolean;
}

export const VolvoPartnerRateTerms = ({
  checked,
  setChecked,
  isError,
}: VolvoPartnerRateTermsProps) => {
  return (
    <>
      <P>
        To add Charge Anytime, you’ll need to agree to the terms and conditions
        for{' '}
        <TextLink
          href={CHARGE_ANYTIME_TERMS_AND_CONDITIONS_LINK}
          opensInNewWindow
        >
          Charge Anytime
        </TextLink>{' '}
        and the{' '}
        <TextLink href={VOLVO_PARTNER_RATE_TERMS_LINK} opensInNewWindow>
          Volvo partner rate
        </TextLink>
        .
      </P>
      <Margin top={4} bottom={8}>
        <StyledTermsCheckbox
          id="chargeAnytimeTerms"
          label="I agree to the Charge Anytime and Volvo partner rate terms."
          checked={checked}
          onChange={() => setChecked(!checked)}
          error={!checked && isError && 'Please tick ok to continue'}
          data-testid="chargeAnytimeTerms"
        />
      </Margin>
    </>
  );
};
